import "@/App.css";

const companies = [
  {
    name: "Royalbet",
    image: "https://customer-assets.emergentagent.com/job_f4c0d341-866c-46fd-89cc-0d02f875c3d8/artifacts/ui38iymw_ChatGPT%20Image%204%20Mar%202026%2013_29_02.png",
    link: "https://royalortaklik.com/links/?btag=2461798"
  },
  {
    name: "Pashagaming",
    image: "https://customer-assets.emergentagent.com/job_f4c0d341-866c-46fd-89cc-0d02f875c3d8/artifacts/4v9yx34s_ChatGPT%20Image%204%20Mar%202026%2013_31_14.png",
    link: "https://eticaretbayimiz.com/links/?btag=2433318"
  },
  {
    name: "Betasus",
    image: "https://customer-assets.emergentagent.com/job_f4c0d341-866c-46fd-89cc-0d02f875c3d8/artifacts/3thcsryj_ChatGPT%20Image%204%20Mar%202026%2013_39_15.png",
    link: "https://asuspartner.com/links/?btag=2598614"
  },
  {
    name: "Ramadabet",
    image: "https://customer-assets.emergentagent.com/job_f4c0d341-866c-46fd-89cc-0d02f875c3d8/artifacts/gohf1vz4_ChatGPT%20Image%204%20Mar%202026%2013_40_01.png",
    link: "https://ramapartner.com/processing/click?btag=8631_9373"
  },
  {
    name: "Venombet",
    image: "https://customer-assets.emergentagent.com/job_f4c0d341-866c-46fd-89cc-0d02f875c3d8/artifacts/jtkwrai6_ChatGPT%20Image%204%20Mar%202026%2013_32_32.png",
    link: "https://tracking.ticaretbayi.com/processing/click?btag=2514_2461"
  },
  {
    name: "Superbet",
    image: "https://customer-assets.emergentagent.com/job_trusted-gamblers/artifacts/hscthvur_ChatGPT%20Image%204%20Mar%202026%2013_34_17.png",
    link: "https://tracker.superortaklik.com/link?btag=96381895_446818"
  },
  {
    name: "Maxwin",
    image: "https://customer-assets.emergentagent.com/job_trusted-gamblers/artifacts/h8hn705q_ChatGPT%20Image%204%20Mar%202026%2013_38_06.png",
    link: "https://track.maxortaklik.com/processing/click?btag=7924_8639"
  }
];

const CompanyCard = ({ company }) => {
  return (
    <a
      href={company.link}
      target="_blank"
      rel="noopener noreferrer"
      className="company-card"
      data-testid={`company-card-${company.name.toLowerCase()}`}
    >
      <div className="card-image-wrapper">
        <img
          src={company.image}
          alt={company.name}
          className="card-image"
          loading="lazy"
        />
      </div>
      <div className="card-name">{company.name}</div>
    </a>
  );
};

function App() {
  return (
    <div className="app-container">
      {/* Animated background particles */}
      <div className="bg-particles">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
        <div className="particle particle-4"></div>
        <div className="particle particle-5"></div>
      </div>

      {/* Header Section */}
      <header className="hero-header">
        <div className="header-glow"></div>
        <div className="crown-icon">
          <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 48L4 20L18 32L32 12L46 32L60 20L56 48H8Z" fill="url(#goldGrad)" stroke="#FFD700" strokeWidth="2"/>
            <rect x="8" y="48" width="48" height="6" rx="2" fill="url(#goldGrad)" stroke="#FFD700" strokeWidth="1"/>
            <circle cx="20" cy="38" r="3" fill="#1a1a2e"/>
            <circle cx="32" cy="34" r="3" fill="#1a1a2e"/>
            <circle cx="44" cy="38" r="3" fill="#1a1a2e"/>
            <defs>
              <linearGradient id="goldGrad" x1="0" y1="0" x2="64" y2="64">
                <stop offset="0%" stopColor="#FFD700"/>
                <stop offset="50%" stopColor="#FFA500"/>
                <stop offset="100%" stopColor="#FFD700"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        <h1 className="hero-title">
          <span className="title-line-1">EN ÇOK KAZANDIRAN</span>
          <span className="title-line-2">GÜVENİLİR SİTELER!</span>
        </h1>
        <div className="header-divider">
          <span className="divider-star">★</span>
          <span className="divider-line"></span>
          <span className="divider-star">★</span>
        </div>
      </header>

      {/* Companies Grid */}
      <main className="companies-section">
        <div className="companies-grid">
          {companies.map((company) => (
            <CompanyCard key={company.name} company={company} />
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="site-footer">
        <p>© 2026 Güvenilir Siteler</p>
      </footer>
    </div>
  );
}

export default App;
